import React, { useCallback, useEffect, useState } from 'react';
import { useFullReset, useKioskState } from '../../../context/Kiosk/kiosk';
import { useLocalization } from '../../../context/Localization/localization';
import { Spinner } from '../../../controls/Spinner/Spinner';
import css from './WorldPayPayment.module.scss';
import { useAppointmentStateUnsafe } from '../../../context/Appointment/appointment';
import { DealerFooter } from './DealerFooter';
import { BillingInformation, WorldPayBillingInformation } from './WorldPayBillingInformation';
import { WorldPayCardInformation } from './WorldPayCardInformation';
import { WorldPayBanner } from './WorldPayBanner';
import { PaymentProvider } from '../../../API/Enums';

interface IProps {
    onSkip: (stripeSessionId?: string) => void;
    onReload: () => void;
    onError: (error: string) => void;
    /**
     * Initial error message to display
     */
    initialErrorMessage: string;
}

export const WorldPayPayment: React.FC<IProps> = ({ onSkip, onReload, onError, initialErrorMessage }) => {
    const appointment = useAppointmentStateUnsafe();
    const Localization = useLocalization();
    const {
        dealer: { onlinePaymentsActive, paymentProvider },
    } = useKioskState();
    const reset = useFullReset(true, false);
    const [paymentErrorMessage, setPaymentErrorMessage] = useState<string>(initialErrorMessage ?? '');
    const [showBillingForm, setShowBillingForm] = useState<boolean>(true);
    const [billingInfo, setBillingInfo] = useState<BillingInformation>({
        Street: '',
        City: '',
        ZipCode: '',
        State: '',
    });

    useEffect(() => {
        if (!appointment || !onlinePaymentsActive || paymentProvider === PaymentProvider.None) {
            reset();
        }
        else if (appointment.paymentStatus === 'no payment due' || appointment.paymentStatus === 'marked paid') {
            onSkip();
        }
    }, [appointment, onSkip, onlinePaymentsActive, paymentProvider, reset]);

    const onTransactionError = useCallback(() => {
        onError(Localization.SomethingWentWrongSelectPayNow);
    }, [Localization.SomethingWentWrongSelectPayNow, onError]);

    return (
        <div className={css.root}>
            {!appointment ||
                appointment.paymentStatus === 'no payment due' ||
                appointment.paymentStatus === 'marked paid' ||
                !onlinePaymentsActive || paymentProvider === PaymentProvider.None ?
                (
                    <Spinner />
                ) : (
                    <>
                        <div className={css.content}>
                            <WorldPayBanner
                                intructionText={showBillingForm ? Localization.PleaseEnterYourBillingAddress : Localization.EnterYourPaymentInformation}
                            />
                            {paymentErrorMessage ?
                                <p className={css.error}>{paymentErrorMessage}</p> :
                                null
                            }
                            <div className={css.form}>
                                {showBillingForm ?
                                    <WorldPayBillingInformation
                                        onProceed={(info: BillingInformation) => {
                                            setBillingInfo(info);
                                            setShowBillingForm(false);
                                            setPaymentErrorMessage('');
                                        }}
                                    /> :
                                    <WorldPayCardInformation
                                        onError={onTransactionError}
                                        onReload={onReload}
                                        onSkip={onSkip}
                                        billingInfo={billingInfo}
                                    />
                                }
                            </div>
                            <DealerFooter />
                        </div>
                    </>
                )}
        </div>
    );
};
